<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="row" v-if="!hideAllFilters">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hideDate="filterDisplay.hideDate"
              ></Filters>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <b-form-group label-for="keyword" label="Keyword">
                <input
                  id="keyword"
                  type="text"
                  class="form-control"
                  v-model="filters.keyword"
                />
              </b-form-group>
            </div>
            <div class="col"></div>
            <div class="col"></div>
            <div class="col text-center"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-button variant="success" v-on:click="goTo('/admin/devices/add')"
            ><i class="fa fa-plus"></i> Add New Device</b-button
          >
        </b-card>
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Devices
          </div>
          <div v-if="!tableReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="tableReady">
            <div v-if="!items.length">
              <b-alert show variant="warning">
                No Devices
              </b-alert>
            </div>
            <table class="table table-striped" v-if="items.length">
              <thead>
                <tr>
                  <th><a href="#" @click.prevent="sort('name')">Name</a></th>
                  <th>Branch</th>
                  <th>Serial</th>
                  <th>Landing Page</th>
                  <th>
                    <a href="#" @click.prevent="sort('dateAdded')"
                      >Date Created</a
                    >
                  </th>
                  <th style="width: 175px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item._id">
                  <td>
                    <router-link
                      :to="{ name: 'Update Device', params: { id: item._id } }"
                      >{{ item.name }}</router-link
                    >
                  </td>
                  <td>{{ item.branch.name }}</td>
                  <td>{{ item.serial }}</td>
                  <td>{{ item.landingPage | formatSlug }}</td>
                  <td>{{ item.dateAdded | formatDate }}</td>
                  <td>
                    <div class="float-left">
                      <b-dropdown
                        id="ddown1"
                        text="Preview"
                        size="sm"
                        v-b-modal.modal1
                        variant="primary"
                      >
                        <b-dropdown-item @click="openPreviewMe(item)"
                          ><i class="fa fa-user"></i>Impersonate
                          Me</b-dropdown-item
                        >
                        <b-dropdown-item @click="openPreviewNew(item)"
                          ><i class="fa fa-plus"></i>New Test
                          User</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                    <button
                      class="btn btn-sm btn-danger ml-1 float-left"
                      @click="deleteItem(item)"
                    >
                      <i class="fa fa-remove"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="float: left;">
              <div class="mb-2">
                <b-form-select
                  style="width: 70px;"
                  id="Limit"
                  :options="limitsList"
                  required
                  v-model="pagination.limit"
                >
                </b-form-select>
                <span> Users per page</span>
              </div>
              <nav>
                <b-pagination
                  :total-rows="pagination.total"
                  :per-page="pagination.limit"
                  v-model="pagination.page"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons
                />
              </nav>
            </div>
          </div>
        </b-card>
        <div class="phone-preview">
          <b-modal
            id="modal1"
            title="WiFi Preview"
            ok-only
            ok-variant="secondary"
            ok-title="Close"
          >
            <div class="iphone6">
              <iframe
                sandbox="allow-same-origin allow-forms allow-scripts"
                seamless=""
                :src="previewSrc"
              ></iframe>
            </div>
          </b-modal>
        </div>
      </b-col> </b-row
    ><!--/.row-->
    <b-modal
      title="Confirm Delete"
      class="modal-danger"
      v-model="deleteModal"
      @ok="confirmDelete()"
      ok-variant="danger"
    >
      <div><b>Are you sure you want to delete this device?</b></div>
      <div>{{ selectedItem.name }}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import common from "./../../../mixins/common";
import filter from "./../../../mixins/filter";
import Filters from "@/views/common/Filters";

export default {
  name: "devices",
  data() {
    return {
      selectedItem: {},
      items: [],
      deleteModal: false,
      tableReady: false,
      previewSrc: "",
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        sort: "dateAdded",
        sortDir: -1
      },
      limits: [10, 50, 100],
      filters: {
        allTime: true
      }
    };
  },
  mixins: [common, filter],
  components: {
    Filters
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    limitsList: function() {
      return this.limits.map(limit => {
        return {
          text: limit,
          value: limit
        };
      });
    }
  },
  methods: {
    apply() {
      this.getItems();
    },
    getItems: function() {
      let scope = this;
      scope.tableReady = false;

      let search = {
        pagination: scope.pagination,
        where: {}
      };

      if (
        scope.filters.company &&
        scope.filters.region &&
        scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region,
          branch: scope.filters.branch
        };
      } else if (
        scope.filters.company &&
        scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region
        };
      } else if (
        scope.filters.company &&
        !scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company
        };
      }

      if (scope.filters.allTime) {
        search.fromDate = scope.$store.getters.allTime.fromDate;
        search.toDate = scope.$store.getters.allTime.toDate;
      } else {
        search.fromDate = scope.filters.fromDate;
        search.toDate = scope.filters.toDate;
      }
      search.keyword = scope.filters.keyword;

      scope.$store.dispatch("getDeviceReport", search).then(
        result => {
          scope.items = result.docs;
          scope.pagination.total = result.total;
          scope.tableReady = true;
        },
        error => {
          console.log(error);
          scope.applying = false;
        }
      );
    },
    deleteItem: function(selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function() {
      this.deleteModal = false;
      let scope = this;
      axios
        .delete(process.env.VUE_APP_API + "/device/" + scope.selectedItem._id, {
          headers: {
            Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
          }
        })
        .then(function(response) {
          scope.getItems();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openPreview(serial, macAddress) {
      let scope = this;
      scope.previewSrc = "";
      setTimeout(() => {
        scope.previewSrc = `${process.env.VUE_APP_MOBILE_URL}/#/redirect?rad=yes&serial=${serial}&client_mac=${macAddress}&client_ip=1.1.1.1&userurl=https://www.hollywoodbets.net&login_url=https://www.hollywoodbets.net&isTester=true`;
      }, 500);
    },
    openPreviewMe(device) {
      this.openPreview(device.serial, this.currentUser.macAddress);
    },
    openPreviewNew(device) {
      let scope = this;
      this.$store.dispatch("generateMacAddress").then(
        result => {
          if (result.user === null) {
            this.openPreview(device.serial, result.macAddress);
          } else {
            console.log(
              `MAC Address ${result.macAddress} not unique. Trying again.`
            );
            this.openPreviewNew(device);
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    sort(sortOrder) {
      if (this.pagination.sortDir === -1) {
        this.pagination.sortDir = 1;
      } else {
        this.pagination.sortDir = -1;
      }
      this.pagination.sort = sortOrder;
      this.getItems();
    }
  },
  created() {
    this.filterDisplay.hideRegion = false;
    this.filterDisplay.hideBranch = false;
    this.filterDisplay.hideDate = false;
    this.setupFilter();
    this.getItems();
  }
};
</script>
